"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayCalculationsFacade = void 0;
exports.ArrayCalculationsFacade = {
    sumOfNElementsRight: (array, numberOfElements) => array.reduceRight((sum, each, idx, a) => {
        return (a.length - idx) > numberOfElements ? sum : sum + each;
    }, 0),
    cumulative: (array) => {
        let sum = 0;
        return array.map(x => sum += x);
    },
    add: (array, numberToAdd) => {
        return array.map(x => x + numberToAdd);
    },
    sumArray: (array) => {
        const newArray = [];
        array.forEach(sub => {
            sub.forEach((num, index) => {
                if (newArray[index]) {
                    newArray[index] += num;
                }
                else {
                    newArray[index] = num;
                }
            });
        });
        return newArray;
    }
};
